<tt-page *ngIf="page">
    <tt-card class="col-xs-12 sp-0">
        <label *ngIf="page.page_heading > ''" class="checklist-h1e col-xs-12">{{ page.page_heading | uppercase }}</label>
        <tt-input ttLabel="resource_name" [ttModel]="page.resource_name" ttReadonly></tt-input>
        <tt-button ttText="srchecklistexpenses_new" ttIcon="fas fa-plus" ttIconPullRight ttTextAlign="left" ttGoto="srchecklistexpense" [ttGotoParms]="{ checklistdata_keyno: page.checklistdata_keyno, srrefundinput_keyno: '0' }"></tt-button>
        <tt-list [ttData]="expenses"></tt-list>
    </tt-card>
</tt-page>
